import { html, CSSResultGroup } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import styles from './chip-group.styles';

/**
 * @slot chipGroupLabel - The component label content
 * @slot default - The slot for chips
 * @csspart base - The component's base wrapper.
 * @csspart part-label - The component's chipGroupLabel slot.
 * @csspart label-text - The component's label text.
 * @csspart default - The component's default slot.
 */
export class BlocksChipGroup extends BlocksElement {static styles: CSSResultGroup = styles;

  /**
   * Aria label attribute
   * - Provides an accessible name for the nav element
   */
  @property({ type: String })
  arialabel = 'chip group';

  /** Label for chip-group. */
  @property({ type: String })
  label: string | undefined;

  /** role for chip-group. */
  @property({ type: String })
  chipGroupRole: string | undefined;

  render() {
    const componentClassNames = this.componentClassNames('cat-c-chip-group', {});

    return html`
      <ul part="base" role=${this.chipGroupRole ?? 'listbox'} aria-label="${this.label} ${this.arialabel}" class="${componentClassNames}">
        <slot
          part="part-label"
          name="chipGroupLabel"
          class="cat-c-chip-group__label ${this.label ? '' : 'cat-c-chip-group__label--hidden'}"
          aria-hidden="true"
          ><label part="label-text">${this.label}</label></slot
        >
        <slot part="default" class="cat-c-chip-items"></slot>
      </ul>
    `;
  }
}

if (customElements.get('cat-chip-group') === undefined) {
  customElements.define('cat-chip-group', BlocksChipGroup);
}

declare global {
  interface HTMLElementTagNameMap {
    'cat-chip-group': BlocksChipGroup;
  }
}
